<template>
  <div class="main scroll" @click="cancelContent" ref="scroll">
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            模板管理
          </div>
        </div>
        <div class="right">
          <!-- <div class="num">
            5
          </div> -->
          <div class="msg">
            <div class="txt blue">模板信息</div>
            <a-icon style="{color:#898989}" type="caret-down" />
          </div>
        </div>
      </div>
      <div class="content" style="margin-bottom: 50px;">
        <ul class="growup">
          <li @click="tapPlate2(currentTpl)">
            <img class="cover" :src="currentTpl.cover" style="width: 130px;margin-bottom: 10px;"  alt="" />
            <div class="name textflow2" style="text-align: center;width: 130px;">本学期模板</div>
          </li>
          
        </ul>
      </div>
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            个人模板
          </div>
        </div>
        <div class="right">
          <div class="num">
            <a-input-search
              style="border: none;"
              v-model="search"
              placeholder="关键字搜索"
              size="small"
              enter-button
              @search="onSearch"
            ></a-input-search>
          </div>
          <div class="msg">
            <div class="txt blue">模板信息</div>
            <a-icon style="{color:#898989}" type="caret-down" />
          </div>
        </div>
      </div>
      <div class="content">
        <a-empty
          description="暂无内容"
          v-if="plateList.length == 0 && load"
          style="margin-top:40px"
        />
        <div class="plate-list">
          <div
            @click="tapPlate(item)"
            v-for="(item, index) in plateList"
            class="cell"
            @contextmenu.prevent="contentRight($event,index)"
          >
            <img class="cover" :src="item.cover" alt="" />
            <div class="name textflow2">{{ item.name }}</div>
            <div class="time">{{ item.create_time2 }}</div>
          </div>
        </div>
        <div
          class="pagebox"
          style="text-align:center;padding-bottom: 20px;padding-top: 10px;"
        >
          <a-pagination
            show-quick-jumper
            :defaultPageSize="9"
            :current="currentPage"
            :total="total"
            @change="onChangePage"
          />
        </div>
      </div>
    </div>
    <a-modal
      :visible="showSaveText"
      centered
      title="编辑文本模板"
      :mask="true"
      @cancel="showSaveText = false"
      @ok="confirmSaveText"
      :closable="true"
    >
      <div class="uploadstate">
        <a-input
          v-model="textTel.name"
          style="margin-bottom: 10px;"
          placeholder="请输入文本模板标题"
        ></a-input>
      </div>
    </a-modal>
    <a-modal
        :visible="showSaveTpl"
        centered
        title="编辑个人模板"
        :mask="true"
        @cancel="showSaveTpl = false"
        @ok="handleSaveToTpl"
        :closable="true"
      >
        <div class="uploadstate">
          <a-input
            v-model="tplName"
            style="margin-bottom: 10px;"
            placeholder="请输入模板名称"
          ></a-input>
        </div>
      </a-modal>
    <div
        v-show="showRight"
        class="rightContent"
        ref="rightContent"
        :style="rightStyle"
      >
        <div @click="showSaveTpl = true" class="cell">编辑模板</div>
        <div @click="delTpl" class="cell">删除模板</div>
      </div>
  </div>

</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import {api} from '../api/api-tpl'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      currentTpl:{},  
      showSaveTpl:false,
      showRight:false,
      plateList: [],
      currentPage: 1,
      currentIndex: -1,
      total: 0,
      tplName:'',
      load: false,
      spinning: false,
      guc_id: "",
      sid: "",
      visible: false,
      search: "",
      rightStyle:{},
      textTel: {
        name: "",
        content: "",
        tc_id: "",
        tm_id: "",
      },
      showSaveText: false,
    };
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    if (this.userInfo) {
      this.getPlate();
      this.initTel();
      this.getPlate2()
    }
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getPlate();
        this.initTel();
        this.getPlate2()
      }
    },
  },
  methods: {
    delTpl() {
      this.$confirm({
        title: "确认删除？",
        content: "删除后数据不可恢复",
        centered: true,
        onOk: () => {
          axios({
            method: "POST",
            url: api.main + api.delPrivateTpl,
            headers: { Authorization: this.headers },
            data: {
              st_id: this.plateList[this.currentIndex].st_id,
            },
          })
            .then((res) => {
              if (res.data.status == 200) {
                this.$message.success(res.data.msg);
                this.getPlate()
                this.currentIndex = -1
              }
            })
            .catch((res) => {
              this.$message.error("操作失败");
              // this.$message('请求错误')
            });
        },
        onCancel() {},
      });
    },
    handleSaveToTpl() {
      if (!this.tplName) {
        this.$message.error('请填写模板名称')
        return 
      }
      axios({
        method: "POST",
        url: api.main + api.changeTplName,
        headers: { Authorization: this.$store.state.headers },
        data: {
          st_id:this.plateList[this.currentIndex].st_id,
          name:this.tplName
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success(res.data.msg);
            this.showSaveTpl = false;
            this.getPlate();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {});
    },
    cancelContent() {
      this.showRight = false
    },
    contentRight(e,index) {
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.tplName = this.plateList[index].name
      this.currentIndex = index
    },
    initTel() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.getTextClass,
        headers: { Authorization: this.headers },
      }).then((res) => {
        if (res.data.status == 200 && res.data.data.data.length > 0) {
          console.log(res.data.data.data);
          this.textTel.tc_id = res.data.data.data[0].tc_id;
        } else {
          this.$axios({
            method: "POST",
            url: this.$api.domain + this.$api.addTextClass,
            headers: { Authorization: this.headers },
            data: {
              name: "分类1",
            },
          }).then((res) => {
            if (res.data.status == 200) {
              this.initTel();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    saveTextTel(tel) {
      this.textTel.name = tel.name;
      this.textTel.content = tel.content;
      this.textTel.tm_id = tel.tm_id;
      this.showSaveText = true;
    },
    confirmSaveText() {
      if (!this.textTel.name) {
        this.$message.error("请先输入文本标题");
        return false;
      }
      axios({
        method: "POST",
        url: this.$api.domain + this.$api.editTextTel,
        headers: { Authorization: this.$store.state.headers },
        data: this.textTel,
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success(res.data.msg);
            this.showSaveText = false;
            this.getPlate();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {});
    },
    onSearch() {
      this.currentPage = 1;
      this.getPlate();
    },
    onChangePage(e) {
      this.currentPage = e;
      this.getPlate();
    },
    tapPlate2(plate) {
      this.$router.push({
        // path: "/mobileGrowup/" + '1098/' + plate.guc_id + '/100',
        path: "/tplPages/" + plate.st_id,
        query: { page: 0 },
      });
    },
    tapPlate(plate) {
      this.$router.push({
        // path: "/mobileGrowup/" + '1098/' + plate.guc_id + '/100',
        path: "/tplPagesPrivate/" + plate.st_id,
        query: { page: 0 ,name: plate.name},
      });
    },
    getPlate2() {

      this.$message.loading({
        key: "load",
        content: "数据读取中",
        duration: 5,
      });
      this.$axios({
        method: "POST",
        url: api.main + api.currentTpl,
        headers: { Authorization: this.headers },
      })
        .then((res) => {
          this.load = true;
          if (res.data.status == 200) {
            this.currentTpl = res.data.data;
          } else {
            this.$message.error({ content: res.data.msg, key: "load" });
          }
        })
        .catch((res) => {
          this.load = true;
          this.$message.error(res.data.msg);
        });
      
    },
    getPlate() {
      this.plateList = [];

      this.$message.loading({
        key: "load",
        content: "数据读取中",
        duration: 5,
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.tplList,
        headers: { Authorization: this.headers },
        data: {
          limit: 9,
          name: this.search,
          page: this.currentPage,
        },
      })
        .then((res) => {
          this.load = true;
          if (res.data.status == 200) {
            this.plateList = res.data.data.list.map(arr=>{
              arr.create_time2 = dayjs(arr.create_time * 1000).format('YYYY-MM-DD HH:mm:ss')
              return arr 
            })
            this.total = res.data.data.count;
            console.log(this.plateList);
            this.$message.success({
              key: "load",
              content: "读取成功",
              duration: 1,
            });
          } else {
            this.$message.error({ content: res.data.msg, key: "load" });
          }
        })
        .catch((res) => {
          this.load = true;
          this.$message.error(res.data.msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tel-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .name {
      font-size: 18px;
      color: #67b0dc;
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
    img {
      width: 18px;
      margin-left: 5px;
      margin-right: 10px;
    }
    .time {
      flex: 1 1 0%;
      text-align: right;
      color: #8a8a8a;
      white-space: nowrap;
    }
  }
  .content {
    margin-top: 10px;
    height: 66px;
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-height: 1.5;
  }
}
.ant-col {
  padding: 10px 20px 10px 0;
}
.main {
  height: 100%;
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}

.tel-list {
  margin-top: 10px;
}
.plate-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  flex-wrap: wrap;
  .cell {
    width: 130px;
    margin-right: 30px;
    margin-bottom: 30px;
    cursor: pointer;
    .cover {
      width: 100%;
      height: 168px;
      background-size: contain;
    }
    .name {
      font-size: 14px;
      color: #333;
      text-align: center;
      margin-top: 15px;
      height: 42px;
      line-height: 20px;
    }

    .time {
      font-size: 14px;
      color: #999;
      text-align: center;
      height: 20px;
      line-height: 20px;
    }
  }
}
.growup {
  font-size: 16px;
  color:#67b0dc;
  margin-top: 20px;
  padding: 0;
}

.growup li{
  cursor: pointer;
  list-style: none;
}
.table {
  margin-top: 30px;
  padding-bottom: 30px;
}
</style>
